var consts = {
    MainUrl: "https://exchange.dreamster.io",
    BackendUrl: "https://exchange.dreamster.io/dreamsterapi",
    socketUrl: 'https://exchange.dreamster.io',
    type: "Production",

    // socketUrl: 'http://localhost:3500',
    // MainUrl: "http://localhost:3000",
    // BackendUrl: "http://localhost:3500/dreamsterapi",
    // type: "Development",

    FutureMainPair: "ETH_USDT",
    MainPair: "BTC_USDT",
    imageurl: 'https://exchange.dreamster.io/dreamsterapi/images/',

    wert_partner_id: "01KH36GF6H27VYK5BJZESSVFM3",
}
export default consts;